import { render } from "./DataMapperInvocations.vue?vue&type=template&id=567bdb5c&scoped=true"
import script from "./DataMapperInvocations.vue?vue&type=script&lang=js"
export * from "./DataMapperInvocations.vue?vue&type=script&lang=js"

import "./DataMapperInvocations.vue?vue&type=style&index=0&id=567bdb5c&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567bdb5c"]])

export default __exports__